module.exports = __webpack_public_path__ + "static/media/img_8.a4d7b512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_8.jpg
// module id = 548
// module chunks = 0